export default class Mention {
    static get isInline() {
        return true
    }

    constructor({ api }) {
        this.api = api
        this.button = null
        this.state = false
    }

    render() {
        this.button = document.createElement('button')
        this.button.type = 'button'
        this.button.innerHTML = '<i class="far fa-at"></i>'
        this.button.hidden = true

        return this.button
    }

    surround(range) {
        let test
        // if (this.state) {
        //     // If highlights is already applied, do nothing for now
        //     return;
        // }

        // const selectedText = range.extractContents();

        // // Create MARK element
        // const mark = document.createElement('span');

        // // Append to the MARK element selected TextNode
        // mark.appendChild(selectedText);

        // // Insert new element
        // range.insertNode(mark);
    }

    checkState(selection) {
        let test
        // const text = selection.anchorNode;

        // if (!text) {
        //     return;
        // }

        // const anchorElement = text instanceof Element ? text : text.parentElement;

        // this.state = !!anchorElement.closest('MARK');
    }

    static get sanitize() {
        return {
            span: function (el) {
                const classList = el.classList.value
                const dataUser = el.getAttribute('data-user')

                if (classList.includes('vbit-mention') && typeof dataUser == 'string') {
                    el.className = 'vbit-mention'
                    return { class: 'vbit-mention', 'data-user': true }
                } else {
                    return false
                }
            },
        }
    }
}
